var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54 7.04a.65.65 0 0 1 .92 0l5 5a.65.65 0 1 1-.92.92L10 8.42l-4.54 4.54a.65.65 0 1 1-.92-.92l5-5Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjU0MDM5IDcuMDQwMzhDOS43OTQyMyA2Ljc4NjU0IDEwLjIwNTggNi43ODY1NCAxMC40NTk2IDcuMDQwMzhMMTUuNDU5NiAxMi4wNDA0QzE1LjcxMzUgMTIuMjk0MiAxNS43MTM1IDEyLjcwNTggMTUuNDU5NiAxMi45NTk2QzE1LjIwNTggMTMuMjEzNSAxNC43OTQyIDEzLjIxMzUgMTQuNTQwNCAxMi45NTk2TDEwIDguNDE5MjRMNS40NTk2MyAxMi45NTk2QzUuMjA1NzggMTMuMjEzNSA0Ljc5NDIzIDEzLjIxMzUgNC41NDAzOSAxMi45NTk2QzQuMjg2NTUgMTIuNzA1OCA0LjI4NjU1IDEyLjI5NDIgNC41NDAzOSAxMi4wNDA0TDkuNTQwMzkgNy4wNDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";